/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExcludeDatapoint
 */
export interface ExcludeDatapoint {
}

/**
 * Check if a given object implements the ExcludeDatapoint interface.
 */
export function instanceOfExcludeDatapoint(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExcludeDatapointFromJSON(json: any): ExcludeDatapoint {
    return ExcludeDatapointFromJSONTyped(json, false);
}

export function ExcludeDatapointFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExcludeDatapoint {
    return json;
}

export function ExcludeDatapointToJSON(value?: ExcludeDatapoint | null): any {
    return value;
}

